import { useEffect, useState } from 'react';

/** The elapsed labels are minute-grained, so a tick every 15 s keeps them within a quarter minute of true. */
export const ELAPSED_TICK_MS = 15 * 1000;

/**
 * A clock, in Unix ms, that re-renders the caller on every tick while
 * `enabled`. For copy that describes a moving quantity ("Publishing · 4
 * minutes", "This time has passed"), so the page keeps up with the list.
 */
export function useNow(enabled = true, intervalMs = ELAPSED_TICK_MS): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!enabled) return;
    setNow(Date.now());
    const timer = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(timer);
  }, [enabled, intervalMs]);
  return now;
}
